import axios from "axios"

const baseUrl = "https://server-api.permianchain.com/api/api/contact"

export const addContact = async contact => {
    return await axios.post(baseUrl, contact)
}
